(function(){
  var P=window.KH_PROD, UNIT=window.KH_UNIT||{};
  if(!P || !P.variants){ return; }
  var euro=function(c){ var pp=(c/100).toFixed(2).split('.'); return pp[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+pp[1]+' €'; };

  // ---- parsing varianti reali ----
  function parse(v){
    var fmt=String(v.option1||''), spe=String(v.option3||''), col=String(v.option2||'');
    var batti=/battiscopa/i.test(fmt);
    var mm=fmt.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/);
    var size=mm ? (mm[1].replace(',','.')+'x'+mm[2].replace(',','.')) : fmt;
    var fin=fmt.replace(/\d+[.,]?\d*\s*[x×]\s*\d+[.,]?\d*/g,' ').replace(/[0-9”"’′']+/g,' ').replace(/(^|\s)[x×](?=\s|$)/gi,' ').replace(/rettificat[oa]|mm|cm|\|/gi,' ').replace(/\s+/g,' ').trim();
    var dest=/R1[1-9]|20\s*mm/i.test(spe) ? 'esterno' : 'interno';
    var img=(v.featured_image&&v.featured_image.src)|| (P.featured_image&&P.featured_image.src) || '';
    var unit=UNIT[v.id]||0;
    return { v:v, id:v.id, fmt:fmt, size:size, fin:fin, col:col, spe:spe, batti:batti, dest:dest,
             price:v.price, unit:unit, img:img, grams:v.grams||v.weight||0, avail:v.available!==false };
  }
  var VS=P.variants.map(parse).filter(function(x){ return x.avail; });
  if(!VS.length) VS=P.variants.map(parse);

  var state={ dest:null, size:null, batti:false, fin:null, col:null, spe:null, qty:1, desiredMq:null };

  function uniq(arr){ var s=[],seen={}; arr.forEach(function(x){ if(x!=null&&x!==''&&!seen[x]){seen[x]=1;s.push(x);} }); return s; }
  function match(f){ return VS.filter(function(x){
    if(state.dest && !x.batti && x.dest!==state.dest) return false;
    if(state.size!=null && x.size!==state.size) return false;
    if(state.batti!=null && x.batti!==state.batti) return false;
    if(f>=3 && state.fin && x.fin!==state.fin) return false;
    if(f>=4 && state.col && x.col!==state.col) return false;
    if(f>=5 && state.spe && x.spe!==state.spe) return false;
    return true;
  }); }
  function currentVariant(){
    var m=match(9);
    if(!m.length) return null;
    // preferisci quella col €/mq più basso (coerente col resto sito)
    m.sort(function(a,b){ return (a.unit||a.price)-(b.unit||b.price); });
    return m[0];
  }
  // selezione completa: ogni step VISIBILE (finitura/colore/spessore) dev'essere scelto
  // (le tappe auto-saltate con 1 sola opzione restano nascoste → non bloccano)
  function fullySelected(){
    if(!state.size) return false;
    function pend(id,val){ var e=document.getElementById('khSec-'+id); return e && e.classList.contains('on') && !val; }
    if(pend('finitura', state.fin)) return false;
    if(pend('colore', state.col)) return false;
    if(pend('spessore', state.spe)) return false;
    return true;
  }

  // ---- costruzione UI ----
  var root=document.createElement('div'); root.id='khCfg';
  root.innerHTML=''
    +'<div id="khSecs"></div>'
    +'<div class="kh-recap" id="khRecap"></div>'
    +'<div class="kh-buy"><button class="kh-cta" id="khCta" disabled>'
    +'<span class="kh-cta-l"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Aggiungi al carrello</span>'
    +'<span class="kh-cta-r"><span class="kh-cta-lbl" id="khTotLbl">TOTALE</span><span class="kh-cta-tot" id="khTot">—</span></span>'
    +'</button></div>';

  function secEl(id,title){
    var s=document.createElement('div'); s.className='kh-sec'; s.id='khSec-'+id;
    s.innerHTML='<div class="kh-hd"><div class="t"><span class="kh-dot"></span>'+title+'</div><div class="pick" id="khPick-'+id+'"></div></div><div class="kh-body" id="khBody-'+id+'"></div>';
    return s;
  }
  var secs=root.querySelector('#khSecs');
  var order=[['dest','Dove la posi'],['formato','Formato'],['finitura','Finitura'],['colore','Colore'],['spessore','Spessore'],['qty','Quantità']];
  order.forEach(function(o){ secs.appendChild(secEl(o[0],o[1])); });

  function show(id){
    var e=document.getElementById('khSec-'+id); e.classList.add('on');
    // apri all'altezza reale del contenuto, poi togli il limite (niente taglio se i colori sono tanti)
    e.style.maxHeight=e.scrollHeight+'px';
    clearTimeout(e._mh); e._mh=setTimeout(function(){ if(e.classList.contains('on')) e.style.maxHeight='none'; }, 450);
  }
  function hide(id){ var e=document.getElementById('khSec-'+id); e.classList.remove('on','done'); e.style.maxHeight=''; document.getElementById('khPick-'+id).textContent=''; }
  function done(id,txt){ document.getElementById('khPick-'+id).textContent=txt; document.getElementById('khSec-'+id).classList.add('done'); }

  function pills(id, items, render, onpick){
    var b=document.getElementById('khBody-'+id); b.innerHTML='<div class="kh-pills"></div>';
    var wrap=b.querySelector('.kh-pills');
    items.forEach(function(it){
      var el=document.createElement('div'); el.className='kh-pill'; el.innerHTML=render(it); el.setAttribute('data-khval',String(it));
      el.onclick=function(){ wrap.querySelectorAll('.kh-pill').forEach(function(x){x.classList.remove('sel');}); el.classList.add('sel'); onpick(it); };
      wrap.appendChild(el);
    });
    return wrap;
  }

  // STEP: DESTINAZIONE
  function buildDest(){
    var d=uniq(VS.filter(function(x){return !x.batti;}).map(function(x){return x.dest;}));
    d.sort(function(a,b){ return (a==='interno'?0:1)-(b==='interno'?0:1); }); // Interno SEMPRE prima di Esterno
    if(d.length<=1){ state.dest=d[0]||'interno'; hideSec('dest'); buildFormato(); show('formato'); return; }
    show('dest');
    pills('dest', d, function(v){ return v==='interno'?'Interno<small>Pavimenti e rivestimenti</small>':'Esterno<small>Antiscivolo'+(VS.some(function(x){return x.dest==="esterno"&&/20\s*mm/i.test(x.spe);})?' / 20mm':'')+'</small>'; },
      function(v){ state.dest=v; state.size=null; state.fin=null; state.col=null; state.spe=null;
        done('dest', v==='interno'?'Interno':'Esterno'); ['finitura','colore','spessore','qty'].forEach(hide); hide('formato');
        buildFormato(); show('formato'); update(); });
  }
  function hideSec(id){ var e=document.getElementById('khSec-'+id); e.classList.remove('on'); e.style.maxHeight=''; }

  // STEP: FORMATO (piastrelle + battiscopa)
  function buildFormato(){
    var pool=VS.filter(function(x){ return x.batti || !state.dest || x.dest===state.dest; });
    var tiles=uniq(pool.filter(function(x){return !x.batti;}).map(function(x){return x.size;}));
    var batti=uniq(pool.filter(function(x){return x.batti;}).map(function(x){return x.size;}));
    // ordina i formati per superficie crescente (dal più piccolo al più grande)
    function areaKey(sz){ var m=/(\d+(?:[.,]\d+)?)[x×](\d+(?:[.,]\d+)?)/.exec(sz||''); return m?parseFloat(m[1].replace(',','.'))*parseFloat(m[2].replace(',','.')):0; }
    tiles.sort(function(a,b){return areaKey(a)-areaKey(b);});
    batti.sort(function(a,b){return areaKey(a)-areaKey(b);});
    // prezzo €/mq minimo per size (mostralo solo se varia)
    function mqFor(sz){ var m=pool.filter(function(x){return x.size===sz&&!x.batti;}); m.sort(function(a,b){return a.unit-b.unit;}); return m[0]?m[0].unit:0; }
    function boxFor(sz){ var m=pool.filter(function(x){return x.size===sz&&!x.batti;}); m.sort(function(a,b){return a.price-b.price;}); return m[0]?m[0].price:0; }
    var mqs=tiles.map(mqFor); var varia = uniq(mqs).length>1; // (non piu' usato per nascondere: il prezzo si mostra SEMPRE)
    var b=document.getElementById('khBody-formato'); b.innerHTML='';
    var wrap=document.createElement('div'); wrap.className='kh-pills'; b.appendChild(wrap);
    tiles.forEach(function(sz){
      var el=document.createElement('div'); el.className='kh-pill';
      // €/mq se disponibile, altrimenti prezzo scatola (mai etichetta /mq sbagliata)
      var _pref = (function(){ var mm=pool.filter(function(x){return x.size===sz&&!x.batti;}); return uniq(mm.map(function(x){return mqFor(sz)?x.unit:x.price;})).length>1?'da ':''; })();
      var tag = mqFor(sz) ? _pref+euro(mqFor(sz))+'/mq' : (boxFor(sz)?_pref+euro(boxFor(sz))+'/scatola':'');
      el.innerHTML=sz.replace('x','×').replace(/\./g,',')+' cm'+(tag?'<small class="kh-mq">'+tag+'</small>':'');
      el.setAttribute('data-khval',sz); el.onclick=function(){ selFormato(sz,false,el,b); }; wrap.appendChild(el);
    });
    if(batti.length){
      var lab=document.createElement('div'); lab.className='kh-grp'; lab.textContent='Battiscopa coordinato · a scatola'; b.appendChild(lab);
      var w2=document.createElement('div'); w2.className='kh-pills'; b.appendChild(w2);
      batti.forEach(function(sz){
        var m=pool.filter(function(x){return x.size===sz&&x.batti;}); m.sort(function(a,b){return a.price-b.price;});
        var el=document.createElement('div'); el.className='kh-pill';
        var _bpref = uniq(m.map(function(x){return x.price;})).length>1?'da ':'';
        el.innerHTML='Battiscopa '+sz.replace('x','×').replace(/\./g,',')+'<small class="kh-mq">'+_bpref+euro(m[0].price)+'/scatola</small>';
        el.setAttribute('data-khval','batti:'+sz); el.onclick=function(){ selFormato(sz,true,el,b); }; w2.appendChild(el);
      });
    }
  }
  function selFormato(sz,batti,el,b){
    b.querySelectorAll('.kh-pill').forEach(function(x){x.classList.remove('sel');}); el.classList.add('sel');
    state.size=sz; state.batti=batti; state.fin=null; state.col=null; state.spe=null;
    done('formato', (batti?'Battiscopa ':'')+sz.replace('x','×').replace(/\./g,',')+(batti?'':' cm'));
    ['finitura','colore','spessore','qty'].forEach(hide);
    buildFinitura(); update();
  }

  // STEP: FINITURA
  function buildFinitura(){
    var pool=match(2);
    var fins=uniq(pool.map(function(x){return x.fin;}));
    if(fins.length<=1){ state.fin=fins[0]||null; hideSec('finitura'); buildColore(); return; }
    var useUnit=pool.some(function(x){return x.unit>0;});
    function finMin(f){ return Math.min.apply(null, pool.filter(function(x){return x.fin===f;}).map(function(x){return x.unit||x.price;})); }
    var base=Math.min.apply(null, fins.map(finMin));
    pills('finitura', fins, function(f){
      var diff=finMin(f)-base; var badge = diff>=50 ? '<span class="kh-up">+'+euro(diff).replace(' €','')+' €'+(useUnit?'/mq':'/scat.')+'</span>' : '';
      return f+badge;
    }, function(f){ state.fin=f; state.col=null; state.spe=null; done('finitura', f); ['colore','spessore','qty'].forEach(hide); buildColore(); update(); });
    show('finitura');
  }

  // STEP: COLORE (swatch con foto reale)
  function buildColore(){
    var pool=match(3);
    var cols=uniq(pool.map(function(x){return x.col;}));
    // 1 solo colore → auto-selezione (nessun clic in piu', va comunque nel carrello)
    if(cols.length<=1){ state.col=cols[0]||null; hideSec('colore'); buildSpessore(); return; }
    var _h=document.querySelector('.fx-product-hero h1, h1'); var _pn=((_h&&_h.textContent)?_h.textContent:(document.title||'').split('–')[0].split('|')[0]).trim();
    function url(u,w){ return u? (u+(u.indexOf('?')>-1?'&':'?')+'width='+w) : ''; }
    // prezzo minimo per colore + base (per il badge "+X" sui colori che costano di più)
    var useUnit=pool.some(function(x){return x.unit>0;});
    function colMin(c){ return Math.min.apply(null, pool.filter(function(x){return x.col===c;}).map(function(x){return x.unit||x.price;})); }
    var mins={}; cols.forEach(function(c){ mins[c]=colMin(c); });
    var base=Math.min.apply(null, cols.map(function(c){return mins[c];}));
    var b=document.getElementById('khBody-colore'); b.innerHTML='<div class="kh-swatches"></div>';
    var wrap=b.querySelector('.kh-swatches');
    cols.forEach(function(c){
      var img=(pool.filter(function(x){return x.col===c&&x.img;})[0]||{}).img||'';
      var diff=mins[c]-base; var badge = diff>=50 ? '<span class="kh-up">+'+euro(diff).replace(' €','')+' €'+(useUnit?'/mq':'/scat.')+'</span>' : '';
      var el=document.createElement('div'); el.className='kh-sw'; el.setAttribute('data-khval',c);
      el.innerHTML='<div class="tick">✓</div><div class="th">'+(img?'<img src="'+url(img,700)+'" alt="'+((_pn?_pn+' - ':'')+c).replace(/"/g,'&quot;')+'" onerror="this.style.display=\'none\'">':'')+'</div><div class="nm">'+c+badge+'</div>';
      el.onclick=function(){ wrap.querySelectorAll('.kh-sw').forEach(function(x){x.classList.remove('sel');}); el.classList.add('sel');
        state.col=c; state.spe=null; done('colore', c); ['spessore','qty'].forEach(hide); buildSpessore(); update(); };
      if(state.col===c) el.classList.add('sel');
      wrap.appendChild(el);
    });
    show('colore');
  }

  // STEP: SPESSORE
  function buildSpessore(){
    var pool=match(4);
    var sps=uniq(pool.map(function(x){return x.spe;}));
    if(sps.length<=1){ state.spe=sps[0]||null; hideSec('spessore'); buildQty(); return; }
    var useUnit=pool.some(function(x){return x.unit>0;});
    function speMin(s){ return Math.min.apply(null, pool.filter(function(x){return x.spe===s;}).map(function(x){return x.unit||x.price;})); }
    var base=Math.min.apply(null, sps.map(speMin));
    function desc(s){ if(/R1[1-9]/i.test(s)) return 'Antiscivolo · esterni'; if(/20\s*mm/i.test(s)) return 'Alto spessore · esterni'; if(/(^|[^0-9])6\s*mm/i.test(s)) return 'Sottile · leggero'; return 'Standard · interni'; }
    pills('spessore', sps, function(s){
      var diff=speMin(s)-base; var badge = diff>=50 ? '<span class="kh-up">+'+euro(diff).replace(' €','')+' €'+(useUnit?'/mq':'/scat.')+'</span>' : '';
      return s+'<small>'+desc(s)+'</small>'+badge;
    }, function(s){ state.spe=s; done('spessore', s); hide('qty'); buildQty(); update(); });
    show('spessore');
  }

  // STEP: QUANTITÀ
  var qtyBuilt=false;
  function boxMqOf(v){ return (v && v.unit>0) ? (v.price/v.unit) : 0; } // m² per scatola
  function buildQty(){
    var b=document.getElementById('khBody-qty');
    var v=currentVariant(); var boxMq=boxMqOf(v);
    if(state.batti || !boxMq){
      // BATTISCOPA / fallback: contatore a scatole
      b.innerHTML='<div class="kh-qty" style="flex-direction:column;gap:14px;align-items:stretch;justify-content:center"><div class="kh-qrow" style="display:flex;align-items:center;justify-content:center;gap:22px"><button class="kh-qbtn" id="khMinus">−</button>'
        +'<div class="kh-qnum"><span id="khQ">'+state.qty+'</span><small id="khQU">scatole</small></div>'
        +'<button class="kh-qbtn" id="khPlus">+</button></div>'
        +'<div id="khShipBuy" style="width:100%;font-size:.85rem;line-height:1.5;color:var(--fx-text,#374151);font-weight:500;text-align:center;margin:0;padding-top:.8rem;border-top:1px solid var(--fx-border,#D9D2C5);"></div></div>'
        +'<div class="kh-stats"><div class="kh-stat"><b id="khS1">—</b><span id="khS1L">pezzi/scatola</span></div>'
        +'<div class="kh-stat"><b id="khS2">—</b><span>pezzi</span></div><div class="kh-stat"><b id="khS3">—</b><span>peso</span></div></div>';
      b.querySelector('#khMinus').onclick=function(){ if(state.qty>1){state.qty--;update();} };
      b.querySelector('#khPlus').onclick=function(){ state.qty++; update(); };
    } else {
      // PIASTRELLE: si inseriscono i m², le scatole si calcolano (arrotondate per eccesso)
      state.desiredMq = +(state.qty*boxMq).toFixed(2);
      b.innerHTML='<div class="kh-qty" style="flex-direction:column;gap:14px;align-items:stretch;justify-content:center"><div class="kh-qrow" style="display:flex;align-items:center;justify-content:center;gap:22px"><button class="kh-qbtn" id="khMinus">−</button>'
        +'<div class="kh-qnum"><input id="khMq" class="kh-mqin" type="text" inputmode="decimal" value="'+String(state.desiredMq).replace('.',',')+'"><small>m² da coprire</small></div>'
        +'<button class="kh-qbtn" id="khPlus">+</button></div>'
        +'<div id="khShipBuy" style="width:100%;font-size:.85rem;line-height:1.5;color:var(--fx-text,#374151);font-weight:500;text-align:center;margin:0;padding-top:.8rem;border-top:1px solid var(--fx-border,#D9D2C5);"></div></div>'
        +'<div class="kh-stats"><div class="kh-stat"><b id="khS1">—</b><span id="khS1L">scatole</span></div>'
        +'<div class="kh-stat"><b id="khS2">—</b><span>pezzi</span></div><div class="kh-stat"><b id="khS3">—</b><span>peso</span></div></div>';
      var inp=b.querySelector('#khMq');
      function fromBoxes(){ state.desiredMq=+(state.qty*boxMq).toFixed(2); inp.value=String(state.desiredMq).replace('.',','); update(); }
      b.querySelector('#khMinus').onclick=function(){ if(state.qty>1){ state.qty--; fromBoxes(); } };
      b.querySelector('#khPlus').onclick=function(){ state.qty++; fromBoxes(); };
      inp.oninput=function(){ var val=parseFloat(inp.value.replace(',','.'))||0; state.desiredMq=val; state.qty=Math.max(1,Math.ceil(val/boxMq - 1e-6)); update(); };
      inp.onblur=function(){ if(!(parseFloat(inp.value.replace(',','.'))>0)){ state.qty=1; fromBoxes(); } };
    }
    qtyBuilt=true; show('qty'); update();
  }

  function updateShow(){
    var img=document.getElementById('khShowImg'); if(!img) return;
    var v=currentVariant();
    var src=(v&&v.img) || (typeof P.featured_image==='string'?P.featured_image:(P.featured_image&&P.featured_image.src)) || (P.images&&P.images[0]&&(P.images[0].src||P.images[0])) || '';
    if(src){ var w=Math.min(2000,Math.round((img.offsetWidth||700)*(window.devicePixelRatio||1))); var u=src+(src.indexOf('?')>-1?'&':'?')+'width='+w; if(img.getAttribute('src')!==u){ img.onload=khShowFit; img.src=u; var bg=document.getElementById('khShowBg'); if(bg) bg.src=u; } }
    var cap=document.getElementById('khShowCap'); if(cap) cap.textContent=state.col||'';
    var _h=document.querySelector('.fx-product-hero h1, h1'); var _pn=((_h&&_h.textContent)?_h.textContent:(document.title||'').split('–')[0].split('|')[0]).trim();
    img.alt=_pn+(state.col?(' - '+state.col):'');
    var _bg=document.getElementById('khShowBg'); if(_bg) _bg.alt=img.alt;
  }
  // se l'immagine sorgente è più piccola di quanto serve: mostrala a misura (sharp) su sfondo sfocato invece di ingrandirla → niente sgranatura
  function khShowFit(){
    var img=document.getElementById('khShowImg'), show=document.getElementById('khShow'); if(!img||!show) return;
    /* i colori riempiono SEMPRE il riquadro (cover), niente versione piccola su sfondo sfocato */
    show.classList.remove('kh-lowres'); img.style.maxWidth=''; img.style.maxHeight='';
  }

  // PIN via JS del blocco showcase (anteprima+badge): riempie il viewport, clamp al fondo.
  function khStick(){
    var showc=document.querySelector('.fx-product-showcase'); if(!showc) return;
    var content=document.querySelector('.fx-product-content'); var visual=showc.parentNode;
    var khShow=document.getElementById('khShow'); var badges=showc.querySelector('.fx-trust-under');
    if(!content||!visual||!khShow) return;
    var ph=document.getElementById('khShowcasePh');
    if(!ph){ ph=document.createElement('div'); ph.id='khShowcasePh'; ph.style.display='none'; visual.insertBefore(ph, showc); }
    if(true){ showc.style.position=''; showc.style.top=''; showc.style.left=''; showc.style.width=''; showc.style.margin=''; showc.style.zIndex=''; khShow.style.height=''; ph.style.display='none'; return; }
    // altezza anteprima COSTANTE (solo viewport) → niente resize
    if(khTopCache<0){
      var _hh=0, _sels=['.Header','.site-header','[data-section-type=header]','.Header__Wrapper','.shopify-section-header','header'];
      for(var _si=0;_si<_sels.length;_si++){ var _els=document.querySelectorAll(_sels[_si]); for(var _ei=0;_ei<_els.length;_ei++){ var _e=_els[_ei], _cs=getComputedStyle(_e), _r=_e.getBoundingClientRect(); if((_cs.position==='fixed'||_cs.position==='sticky') && _r.top<=1 && _r.height>_hh) _hh=_r.height; } }
      if(_hh>0) khTopCache=Math.round(_hh)+14;
    }
    var TOP = khTopCache>0 ? khTopCache : 14;
    var targetH = Math.max(240, Math.round(window.innerHeight - TOP - 18 - 210))+'px'; // riservati ~210px ai 4 badge + header
    if(khShow.style.height!==targetH) khShow.style.height=targetH;
    var pinned = showc.style.position==='fixed';
    var natTop = pinned ? ph.getBoundingClientRect().top : showc.getBoundingClientRect().top;
    var cRect = content.getBoundingClientRect();
    var h = pinned ? ph.offsetHeight : showc.offsetHeight;
    if(natTop<=TOP){
      // cattura pos/width naturale UNA VOLTA → left/width fissi (niente shift)
      if(!khBox){ var r=showc.getBoundingClientRect(); khBox={left:Math.round(r.left), width:Math.round(r.width)}; }
      ph.style.display='block'; ph.style.height=h+'px'; ph.style.width=khBox.width+'px';
      var topPos=Math.min(TOP, Math.round(cRect.bottom - h)); // clamp al fondo del contenuto
      showc.style.position='fixed'; showc.style.top=topPos+'px'; showc.style.left=khBox.left+'px'; showc.style.width=khBox.width+'px'; showc.style.margin='0'; showc.style.zIndex='6';
    } else {
      showc.style.position=''; showc.style.top=''; showc.style.left=''; showc.style.width=''; showc.style.margin=''; showc.style.zIndex=''; ph.style.width='';
      ph.style.display='none'; khBox=null;
    }
  }
  var khBox=null, khTk=false, khTopCache=-1;
  function khStickReq(){ if(khTk) return; khTk=true; requestAnimationFrame(function(){ khTk=false; khStick(); }); }
  function khOnResize(){ khBox=null; khTopCache=-1; var s=document.querySelector('.fx-product-showcase'); if(s){ s.style.position=''; s.style.left=''; s.style.width=''; } khStickReq(); }

  // ---- NOTA SPEDIZIONE (#fxShipNote): stessi input del worker kreo-shipping (state.size + state.spe) → combacia col checkout ----
  function khThNum(s){ var m=String(s||'').match(/(\d+(?:[.,]\d+)?)\s*mm/i); if(m) return m[1].replace(',','.'); var m2=String(s||'').match(/(\d+(?:[.,]\d+)?)/); return m2?m2[1].replace(',','.'):''; }
  function khFmtN(s){ var m=String(s||'').replace(/×/g,'x').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/); return m?(m[1].replace(',','.')+'x'+m[2].replace(',','.')):''; }
  function khGroup(fmt, spe){
    var is20=khThNum(spe)==='20';
    if(fmt==='120x120') return is20?'G8':'G4';
    if(['120x280','120x278','120x240'].indexOf(fmt)>=0) return 'G5';
    if(fmt==='160x320') return khThNum(spe)==='12'?'G6':'G7';
    if(fmt==='150x300') return 'G7';
    if(fmt==='150x150') return 'G3';
    if(fmt==='75x150') return 'G4';
    if(['80x160','80x180','20x180','26.5x160','26.5x180','90x180'].indexOf(fmt)>=0) return 'G3';
    if(is20) return 'G2';
    return 'G1';
  }
  // default = range REALE calcolato dai formati di QUESTO prodotto (così le lastre non spariscono dal 122-183)
  var _khRangeHtml=null;
  function khDefaultHtml(){
    if(_khRangeHtml) return _khRangeHtml;
    _khRangeHtml='IVA inclusa <span style="opacity:.45">&middot;</span> Spedizione <span style="color:#2D5A3D;font-weight:700">gratuita</span>';
    return _khRangeHtml;
  }
  function khShipNote(){
    var note=document.getElementById('fxShipNote');
    var buy=document.getElementById('khShipBuy');
    // TOP (#fxShipNote, accanto al prezzo): resta SEMPRE sul default/range del prodotto — richiesta capo, non per-formato
    if(note){ var def=khDefaultHtml(); if(note.innerHTML!==def) note.innerHTML=def; }
    // BOTTOM (#khShipBuy, vicino al TOTALE): valore ESATTO per il formato selezionato
    if(!buy) return;
    var compact='<span class="kh-shl">Spedizione <span style="color:#2D5A3D;font-size:1.1em;font-weight:700">gratuita</span></span>';
    if(buy.innerHTML!==compact) buy.innerHTML=compact;
  }

  function update(){
    updateShow();
    khStickReq();
    try{ khShipNote(); }catch(e){}
    var v=currentVariant();
    var totLbl=document.getElementById('khTotLbl'), tot=document.getElementById('khTot'), cta=document.getElementById('khCta');
    var recap=document.getElementById('khRecap');
    if(!v || !state.size){ totLbl.textContent='TOTALE'; tot.textContent='—'; cta.disabled=true; if(recap) recap.innerHTML=''; return; }
    // stat quantità
    if(qtyBuilt && document.getElementById('khSec-qty').classList.contains('on')){
      var boxMq = boxMqOf(v);
      var qEl=document.getElementById('khQ'); if(qEl) qEl.textContent=state.qty; // solo battiscopa/fallback
      if(state.batti || !boxMq){
        var qu=document.getElementById('khQU'); if(qu) qu.textContent='scatole';
        document.getElementById('khS1L').textContent=state.batti?'pezzi/scatola':'scatole';
        /* KH-BATTI-PZ 2026-10-07: pezzi/scatola e peso REALI del battiscopa dal dato specifiche (window.__KH_BATTI__), non piu' il "10" fisso ne' i grammi segnaposto (19000). */
        var _bInfo = state.batti ? ((window.__KH_BATTI__||{})[state.size] || null) : null;
        /* KH-M4b 2026-10-08: niente "10" finto. Se manca il dato pezzi/scatola del battiscopa -> "su richiesta". */
        var _hasPz = !!(_bInfo && _bInfo.pz);
        var _bPz = _hasPz ? _bInfo.pz : null;
        var _bKg = (_bInfo && _bInfo.kg) ? _bInfo.kg : null;
        var _s1=document.getElementById('khS1');
        if(state.batti && !_hasPz){
          _s1.textContent='su richiesta'; _s1.style.fontSize='0.8rem'; _s1.style.fontWeight='600';
          document.getElementById('khS2').textContent='—';
        } else {
          _s1.style.fontSize=''; _s1.style.fontWeight='';
          _s1.textContent=state.batti?String(_bPz):state.qty;
          document.getElementById('khS2').textContent=state.batti?(state.qty*_bPz):'—';
        }
        /* KH-M5b 2026-10-08: battiscopa SENZA dato reale -> niente peso finto (19 kg placeholder), mostra "—". */
        document.getElementById('khS3').textContent=(state.batti && !_hasPz)?'—':((state.batti && _bKg)?(String(Math.round(state.qty*_bKg*10)/10).replace('.',',')+' kg'):((v.grams?Math.round(state.qty*v.grams/1000):'—')+' kg'));
      } else {
        document.getElementById('khS1L').textContent='scatole';
        document.getElementById('khS1').textContent=state.qty;
        var szm=state.size.split('x'); var pzBox = (szm[1])? Math.max(1,Math.round(boxMq/((+szm[0]/100)*(+szm[1]/100)))):'—';
        document.getElementById('khS2').textContent=(pzBox==='—')?'—':state.qty*pzBox;
        document.getElementById('khS3').textContent=(v.grams?Math.round(state.qty*v.grams/1000):'—')+' kg';
      }
    }
    // RIEPILOGO config (mostra anche i valori auto-selezionati, es. spessore)
    if(recap){
      var parts=[]; // ordine = come gli step: Destinazione → Formato → Finitura → Colore → Spessore
      if(state.dest) parts.push(state.dest==='interno'?'Interno':'Esterno');
      parts.push((state.batti?'Battiscopa ':'')+state.size.replace('x','×').replace(/\./g,',')+(state.batti?'':' cm'));
      if(state.fin) parts.push(state.fin);
      if(state.col) parts.push(state.col);
      if(state.spe) parts.push(state.spe);
      recap.innerHTML=parts.map(function(pp){return '<span>'+pp+'</span>';}).join('');
    }
    // TOTALE vicino al carrello
    var _ready=!!(fullySelected() && v);
    var unita=(state.qty===1?'SCATOLA':'SCATOLE');
    totLbl.textContent=_ready?('TOTALE · '+state.qty+' '+unita):'TOTALE';
    tot.textContent=_ready?euro(state.qty*v.price):'—';
    cta.disabled = !_ready;
  }

  /* KH-BATTI-PZ 2026-10-07: quando ceramica-euro-config ha caricato le specifiche (window.__KH_BATTI__ pronto), ri-renderizza cosi' i pezzi/scatola e il peso del battiscopa diventano quelli reali. */
  document.addEventListener('kh:batti-ready', function(){ try{ update(); }catch(e){} });

  // apre il cart drawer (#sidebar-cart) come faceva il vecchio motore: eventi di refresh + click sul trigger open-drawer
  function openCartDrawer(){
    ['cart:updated','cart:refresh','cart:item-added','cart:build','ajaxCart:updated'].forEach(function(ev){
      try{ document.dispatchEvent(new CustomEvent(ev,{bubbles:true})); window.dispatchEvent(new CustomEvent(ev,{})); }catch(e){}
    });
    var trig=document.querySelector('a[href="/cart"][data-action="open-drawer"]')
          || document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')
          || document.querySelector('[data-action="open-drawer"]');
    if(trig){ setTimeout(function(){ trig.click(); }, 300); return true; }
    var cd=document.querySelector('cart-drawer'); if(cd && typeof cd.open==='function'){ cd.open(); return true; }
    return false;
  }

  // ADD TO CART (variante reale)
  root.querySelector('#khCta').addEventListener('click', function(){
    var v=currentVariant(); if(!v || !fullySelected()) return;
    var cta=this; cta.disabled=true; var old=cta.innerHTML; cta.textContent='Aggiunta…';
    var props={ 'Formato': state.size.replace('x','×').replace(/\./g,',') };
    if(state.col) props['Colore']=state.col;
    if(state.fin) props['Finitura']=state.fin;
    if(state.spe) props['Spessore']=state.spe;
    if(state.batti){ var _bi=(window.__KH_BATTI__||{})[state.size]; var _bpz=(_bi&&_bi.pz)?_bi.pz:null; props['Tipo']= _bpz?('Battiscopa (scatola '+_bpz+' pz)'):'Battiscopa (a scatola)'; }
    else if(v.unit){ props['Superficie']= (state.qty*(v.price/v.unit)).toFixed(2).replace('.',',')+' m²'; props['Prezzo alla scatola']= euro(v.price); props['_Prezzo_Mq']= euro(v.unit)+'/mq'; props['_Total_Mq']= String(+(state.qty*(v.price/v.unit)).toFixed(2)); props['_Mq_Per_Box']= String(+(v.price/v.unit).toFixed(4)); }
    else { props['Prezzo a scatola']= euro(v.price); }
    function fail(){ cta.disabled=false; cta.innerHTML=old; alert('Errore aggiunta al carrello, riprova.'); }
    function add(attempt){
      fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ id:v.id, quantity:state.qty, properties:props }) })
      .then(function(r){
        if(r.status===429 && attempt<6){ return setTimeout(function(){ add(attempt+1); }, 700); } // retry anti-bot/rate-limit
        if(!r.ok){ throw 0; }
        return r.json().then(function(){ cta.disabled=false; cta.innerHTML=old; if(!openCartDrawer()){ window.location.href='/cart'; } });
      })
      .catch(function(){ if(attempt<6){ setTimeout(function(){ add(attempt+1); }, 700); } else { fail(); } });
    }
    add(0);
  });

  // ---- monta SOPRA i pulsanti esistenti ----
  function khPreselectVariant(){
    try{
      var m=(location.search||'').match(/[?&]variant=(\d+)/); if(!m) return;
      var tv=(P.variants||[]).filter(function(x){return String(x.id)===m[1];})[0]; if(!tv) return;
      var pv=parse(tv);
      if(pv.batti){
        /* KH-BATTPRESELECT 2026-10-06: con ?variant= di un battiscopa seleziona la pill battiscopa (data-khval 'batti:'+size) + finitura/colore/spessore. Se c'e' lo step "Dove la posi" (Interno/Esterno) la sezione FORMATO non esiste ancora: seleziona prima il dest (battiscopa = interno) e riprova. Abilita 'Aggiungi al carrello'. */
        var _khClickBatti=function(){
          var fb=document.getElementById('khBody-formato'); if(!fb) return false;
          var bp=fb.querySelectorAll('.kh-pill');
          for(var j=0;j<bp.length;j++){ if(bp[j].getAttribute('data-khval')==='batti:'+pv.size){ if(!bp[j].classList.contains('sel')) bp[j].click(); return true; } }
          return false;
        };
        if(!_khClickBatti()){
          var _db=document.getElementById('khBody-dest');
          if(_db){
            var _dp=_db.querySelectorAll('.kh-pill, .kh-sw'); var _cands=[pv.dest,'interno']; var _dn=false;
            for(var _c=0;_c<_cands.length && !_dn;_c++){ if(!_cands[_c]) continue; for(var _k=0;_k<_dp.length;_k++){ if(_dp[_k].getAttribute('data-khval')===String(_cands[_c])){ if(!_dp[_k].classList.contains('sel')) _dp[_k].click(); _dn=true; break; } } }
            if(!_dn && _dp.length){ if(!_dp[0].classList.contains('sel')) _dp[0].click(); }
          }
          _khClickBatti();
        }
        [['finitura',pv.fin],['colore',pv.col],['spessore',pv.spe]].forEach(function(st){
          var val=st[1]; if(val==null||val==='') return;
          var body=document.getElementById('khBody-'+st[0]); if(!body) return;
          var els=body.querySelectorAll('.kh-pill, .kh-sw'); if(!els.length) return;
          for(var i=0;i<els.length;i++){ if(els[i].getAttribute('data-khval')===String(val)){ if(!els[i].classList.contains('sel')) els[i].click(); break; } }
        });
        return;
      }
      [['dest',pv.dest],['formato',pv.size],['finitura',pv.fin],['colore',pv.col],['spessore',pv.spe]].forEach(function(st){
        var val=st[1]; if(val==null||val==='') return;
        var body=document.getElementById('khBody-'+st[0]); if(!body) return;
        var els=body.querySelectorAll('.kh-pill, .kh-sw'); if(!els.length) return;
        for(var i=0;i<els.length;i++){ if(els[i].getAttribute('data-khval')===String(val)){ if(!els[i].classList.contains('sel')) els[i].click(); break; } }
      });
    }catch(e){}
  }
  function mount(){
    var cta=document.querySelector('.fx-cta-section');
    if(!cta){ return setTimeout(mount,150); }
    // CLONA la Klarna dentro #khCfg PRIMA di inserirlo → nasce già sotto il pulsante, nessuno spostamento/reflow. L'originale resta nascosto (display:none via <style> nel template).
    var origK=document.querySelector('.fx-payment-section');
    if(origK && !root.querySelector('.fx-payment-section')){
      var kc=origK.cloneNode(true); kc.classList.add('kh-klarna');
      // logo Klarna INLINE al posto della parola "Klarna", niente logo grande separato
      var _li=kc.querySelector('.fx-payment-logos img'); var _lsrc=_li?_li.getAttribute('src'):'';
      var _row=kc.querySelector('.fx-payment-row');
      if(_row && _lsrc){ _row.innerHTML=_row.innerHTML.replace(/Klarna/i,'<img src="'+_lsrc+'" alt="Klarna" class="kh-klogo">'); }
      var _logos=kc.querySelector('.fx-payment-logos'); if(_logos) _logos.style.display='none';
      root.appendChild(kc); origK.remove();
    }
    function centerKlarna(){
      var k=document.querySelector('#khCfg .fx-payment-section'); if(!k) return;
      k.style.setProperty('display','block','important'); k.style.setProperty('width','100%','important'); k.style.setProperty('opacity','1','important'); k.style.textAlign='center';
      var r=k.querySelector('.fx-payment-row'); if(r){ r.style.setProperty('display','block','important'); r.style.setProperty('width','100%','important'); r.style.setProperty('text-align','center','important'); }
    }
    centerKlarna();
    if(!document.getElementById('khCfg')){ cta.parentNode.insertBefore(root, cta); }
    centerKlarna();
    // anteprima showroom nella colonna sinistra (sopra al vecchio showcase, che viene nascosto via CSS)
    var showc=document.querySelector('.fx-product-showcase');
    if(showc && !document.getElementById('khShow')){
      var sh=document.createElement('div'); sh.id='khShow';
      sh.innerHTML='<img id="khShowBg" alt="" aria-hidden="true"><img id="khShowImg" alt=""><div class="kh-show-cap" id="khShowCap"></div>';
      showc.insertBefore(sh, showc.firstChild);
    }
    window.addEventListener('scroll', khStickReq, {passive:true});
    window.addEventListener('resize', khOnResize);
    var _si=document.getElementById('khShowImg'); if(_si) _si.addEventListener('load', khStickReq);
    buildDest();
    // primo bordo via
    document.getElementById('khSec-'+order[0][0]).classList.add('kh-first');
    var firstOn=root.querySelector('.kh-sec.on'); if(firstOn) firstOn.classList.add('kh-first');
    update();
    try{khPreselectVariant();}catch(e){}
  }
  if(document.readyState!=='loading') mount(); else document.addEventListener('DOMContentLoaded', mount);
})();